const API_KEY = "xYlLRyuJYpNbrxCySQzIEY7d6ni1";
const URL = `https://cricapi.com/api/matches?apikey=${API_KEY}`;


export async function api() {
    try {
        const response = await fetch(URL);
        return await response.json();
    } catch (error) {
        return console.log("Error :", error);
    }
}

